import { isCustomExpand as commonIsCustomExpand } from './common';

const useExpandable = (customExpandable) => {
  const { rowExpandable } = customExpandable;

  const isCustomExpand = () => {
    return commonIsCustomExpand(customExpandable);
  };

  const setRowExpandable = (row) => {
    if (isCustomExpand()) return rowExpandable(row.original);
    return Array.isArray(row.original?.subRows);
  };

  return { setRowExpandable, isCustomExpand };
};

export default useExpandable;
